import React, { useState, useEffect } from 'react';

import './style.css';

// Alumni Card Placeholder Component
const AlumniCardPlaceholder: React.FC = () => {
    return (
        <div className="alumni-card">
            {/* Header Section Placeholder */}
            <div className="alumni-card-header doctor">
                <div className="d-flex justify-content-between align-items-start">
                    <div>
                        {/* Degree tags placeholder */}
                        <div className="placeholder-glow mb-2">
                            <div className="placeholder bg-white bg-opacity-75 rounded-pill" style={{ height: '24px', width: '60px', display: 'inline-block', marginRight: '4px' }}></div>
                            <div className="placeholder bg-white bg-opacity-75 rounded-pill" style={{ height: '24px', width: '80px', display: 'inline-block' }}></div>
                        </div>
                    </div>
                    {/* Header icon placeholder */}
                    <div className="alumni-header-icon">
                        <div className="placeholder-glow">
                            <div className="placeholder bg-white bg-opacity-75 rounded" style={{ height: '12px', width: '12px' }}></div>
                        </div>
                    </div>
                </div>
                
                {/* Name and Position placeholder */}
                <div className="mt-3">
                    <div className="placeholder-glow mb-2">
                        <div className="placeholder bg-white bg-opacity-75 rounded" style={{ height: '22px', width: '80%' }}></div>
                    </div>
                    <div className="placeholder-glow">
                        <div className="placeholder bg-white bg-opacity-75 rounded" style={{ height: '16px', width: '90%' }}></div>
                    </div>
                </div>
            </div>

            {/* Image Section Placeholder */}
            <div className="alumni-image-container">
                <div className="alumni-loading">
                    <div className="d-flex flex-column align-items-center">
                        <div className="spinner-border text-warning mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="placeholder-glow">
                            <div className="placeholder bg-secondary rounded" style={{ height: '16px', width: '120px' }}></div>
                        </div>
                    </div>
                </div>

                {/* View Story Button Placeholder */}
                <div className="alumni-view-story-btn">
                    <div className="placeholder-glow d-flex align-items-center gap-2">
                        <div className="placeholder bg-secondary rounded" style={{ height: '14px', width: '60px' }}></div>
                        <div className="placeholder bg-secondary rounded" style={{ height: '12px', width: '12px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Alumni Carousel Placeholder Component
const AlumniCarouselPlaceholder: React.FC = () => {
    const [visibleCards, setVisibleCards] = useState(4);

    // Responsive breakpoints - same logic as main component
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) {
                setVisibleCards(1);
            } else if (window.innerWidth < 769) {
                setVisibleCards(2);
            } else if (window.innerWidth < 1024) {
                setVisibleCards(3);
            } else if (window.innerWidth < 1280) {
                setVisibleCards(4);
            } else {
                setVisibleCards(4);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Generate placeholder cards
    const placeholderCards = Array.from({ length: 8 }, (_, index) => (
        <div key={index} className="alumni-card-item">
            <AlumniCardPlaceholder />
        </div>
    ));

    // Calculate progress indicators
    const progressCount = Math.max(1, Math.ceil(8 / visibleCards));

    return (
        <div className="position-relative">
            {/* Carousel Container */}
            <div className="alumni-carousel-container">
                {/* Cards Container */}
                <div className="alumni-cards-wrapper">
                    {placeholderCards}
                </div>
            </div>

            {/* Navigation Arrows Placeholder */}
            <button
                disabled
                className="alumni-nav-button prev"
                aria-label="Previous alumni"
            >
                <div className="placeholder-glow">
                    <div className="placeholder bg-secondary rounded" style={{ height: '16px', width: '16px' }}></div>
                </div>
            </button>

            <button
                disabled
                className="alumni-nav-button next"
                aria-label="Next alumni"
            >
                <div className="placeholder-glow">
                    <div className="placeholder bg-secondary rounded" style={{ height: '16px', width: '16px' }}></div>
                </div>
            </button>

            {/* Progress Indicators Placeholder */}
            <div className="alumni-progress-indicators">
                {Array.from({ length: progressCount }, (_, i) => (
                    <button
                        key={i}
                        disabled
                        className="alumni-progress-dot"
                        aria-label={`Go to slide ${i + 1}`}
                    >
                        <div className="placeholder-glow">
                            <div className="placeholder bg-secondary rounded-circle" style={{ height: '12px', width: '12px' }}></div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

const AlumniCTAButtonPlaceholder: React.FC = () => {
    return (
        <div className='d-flex justify-content-center align-items-center mt-4'>
            <div className="alumni-cta-button" style={{ pointerEvents: 'none' }}>
                <div className="placeholder-glow">
                    <div className="placeholder bg-white bg-opacity-75 rounded" style={{ height: '20px', width: '200px' }}></div>
                </div>
            </div>
        </div>
    );
};

// Main Alumni Placeholder Component
const AlumniPlaceholder: React.FC = () => {
    return (
        <>
            {/* Alumni Carousel Placeholder */}
            <AlumniCarouselPlaceholder />

            {/* Call to Action Button Placeholder */}
            <AlumniCTAButtonPlaceholder />
        </>
    );
};

export { AlumniPlaceholder, AlumniCardPlaceholder, AlumniCarouselPlaceholder, AlumniCTAButtonPlaceholder }; 